<app-dashboard-header></app-dashboard-header>

<div class="dashboard-content">
  <section class="schedule-section">
    <h1 class="page-title">Training Schedule</h1>
    <div class="schedule-controls">
      <mat-tab-group
        class="schedule-tab-group"
        [selectedIndex]="selectedScheduleTabIndex"
        (selectedIndexChange)="onScheduleTabChange($event)"
        animationDuration="0ms"
      >
        <mat-tab *ngFor="let schedule of scheduleListData.items$ | async" [label]="schedule.name"></mat-tab>
      </mat-tab-group>
    </div>

    <ng-container *ngIf="(scheduleListData.isLoading$ | async) || (scheduleDetailData.isLoading$ | async); else checkEmpty">
      <app-table-skeleton [rows]="4" [columns]="3"></app-table-skeleton>
    </ng-container>

    <ng-template #checkEmpty>
      <ng-container *ngIf="(scheduleDetailData.sessions$ | async)?.length === 0; else scheduleContent">
        <div class="no-data">
          <mat-icon>event_busy</mat-icon>
          <p>No schedule data available.</p>
          <div style="display: flex; gap: 12px; justify-content: center;">
            <button mat-raised-button color="primary" (click)="generateAndFetchSchedule(false)">Refresh</button>
            <button mat-raised-button color="accent" (click)="generateAndFetchSchedule(true)">Recreate</button>
            <button mat-raised-button color="accent" (click)="openScheduleAnalysis()">Analyze</button>
            <button mat-raised-button color="primary" (click)="openTechnicalAnalysis()">Technical</button>
          </div>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #scheduleContent>
      <div class="schedule-container">
      <mat-card class="schedule-card">
        <mat-card-header>
          <div class="card-header-main">
            <div>
              <ng-container *ngIf="selectedScheduleVersionInfo.number">
                <div class="version-badge-container">
                  <span class="version-badge">
                    <mat-icon class="version-badge-icon" fontIcon="verified" aria-hidden="true"></mat-icon>
                    v{{ selectedScheduleVersionInfo.number }}
                    <ng-container *ngIf="selectedScheduleVersionInfo.name">
                      &nbsp;–&nbsp;{{ selectedScheduleVersionInfo.name }}
                    </ng-container>
                  </span>
                </div>
              </ng-container>
            </div>
            <div class="card-header-actions-right">
              <div class="custom-view-selector custom-view-selector-bordered with-refresh">
                <button
                  class="custom-view-btn"
                  [class.selected]="viewMode === 'day'"
                  (click)="setViewMode('day')"
                  type="button"
                  aria-label="Switch to Day View"
                >
                  <mat-icon>calendar_today</mat-icon>
                  <span>Day</span>
                </button>
                <button
                  class="custom-view-btn"
                  [class.selected]="viewMode === 'resource'"
                  (click)="setViewMode('resource')"
                  type="button"
                  aria-label="Switch to Resource View"
                >
                  <mat-icon>person_search</mat-icon>
                  <span>Resource</span>
                </button>
                <button
                  class="custom-view-btn"
                  [class.selected]="viewMode === 'typeperday'"
                  (click)="setViewMode('typeperday')"
                  type="button"
                  aria-label="Switch to Resource Type per Day View"
                  style="margin-left:auto;"
                >
                  <mat-icon>table_view</mat-icon>
                  <span>Type / Day</span>
                </button>
                <button
                  class="refresh-btn-square"
                  (click)="generateAndFetchSchedule(false)"
                  type="button"
                  aria-label="Refresh"
                >
                  <mat-icon>refresh</mat-icon>
                </button>
                <button
                  class="analysis-btn-square"
                  (click)="openScheduleAnalysis()"
                  type="button"
                  aria-label="Analyze Schedule"
                  [disabled]="!selectedScheduleVersionInfo.number"
                >
                  <mat-icon>psychology</mat-icon>
                </button>
                <button
                  class="technical-analysis-btn-square"
                  (click)="openTechnicalAnalysis()"
                  type="button"
                  aria-label="Technical Analysis"
                  [disabled]="!selectedScheduleVersionInfo.number"
                >
                  <mat-icon>code</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </mat-card-header>

        <mat-card-content>
          <ng-container [ngSwitch]="viewMode">
            <!-- Day View -->
            <ng-container *ngSwitchCase="'day'">
              <mat-tab-group animationDuration="300ms" [selectedIndex]="selectedTabIndex">
                <mat-tab *ngFor="let day of days; let i = index" [label]="day" [disabled]="!sessionsByDay[i+1].length">
                  <div class="day-schedule">
                    <div *ngIf="!sessionsByDay[i+1].length" class="no-sessions">
                      <p>No sessions scheduled for {{ day }}</p>
                    </div>

                    <div *ngIf="sessionsByDay[i+1].length" class="schedule-table-wrapper">
                      <table class="schedule-table">
                        <thead>
                          <tr>
                            <th class="table-time-col">Time</th>
                            <th *ngFor="let typeSlug of resourceTypeSlugs" class="table-resource-col">
                              <mat-icon
                                class="table-resource-icon table-resource-icon-header"
                                inline="true"
                                [fontIcon]="getResourceTypeIcon(typeSlug) || 'person'"
                                aria-hidden="true"
                                style="margin-right: 0.25em;"
                              ></mat-icon>
                              {{ getResourceTypeName(typeSlug) }}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let session of sessionsByDay[i+1]">
                            <td class="table-time-col">
                              <span class="table-time">{{ session.startTime }} - {{ session.endTime }}</span>
                            </td>
                            <td *ngFor="let typeSlug of resourceTypeSlugs" class="table-resource-col">
                              <span class="table-resource" [title]="getResourceTypeName(typeSlug)">
                                <mat-icon
                                  class="table-resource-icon"
                                  inline="true"
                                  [fontIcon]="getResourceTypeIcon(typeSlug) || 'person'"
                                  aria-hidden="true"
                                ></mat-icon>
                                <span class="table-resource-name">{{ getResourceByType(session, typeSlug)?.name || 'N/A' }}</span>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </mat-tab>
              </mat-tab-group>
            </ng-container>
            <!-- Resource View -->
            <ng-container *ngSwitchCase="'resource'">
              <div style="display: flex; gap: 1.5em; align-items: flex-end; margin-bottom: 1.5em;">
                <!-- Resource type selector -->
                <mat-form-field appearance="outline" style="min-width: 200px; margin-top: 0; margin-bottom: 0;">
                  <mat-label>Resource Type</mat-label>
                  <mat-select [(value)]="selectedResourceTypeSlug" (selectionChange)="onResourceTypeChange($event.value)">
                    <mat-option *ngFor="let rt of scheduleDetailData.resourceTypes$ | async" [value]="rt.slug">
                      <mat-icon [fontIcon]="getResourceTypeIcon(rt.slug) || 'person'" style="margin-right: 0.5em;"></mat-icon>
                      {{ rt.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- Resource selector -->
                <mat-form-field appearance="outline" style="min-width: 220px; margin-top: 0; margin-bottom: 0;" *ngIf="resourceListForType.length > 0 && selectedResourceTypeSlug || selectedResourceId">
                  <mat-label>Resource</mat-label>
                  <mat-select [(value)]="selectedResourceId" (selectionChange)="onResourceSelect($event.value)">
                    <mat-option *ngFor="let r of resourceListForType" [value]="r.id">
                      {{ r.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!selectedResourceId" class="no-sessions">
                <p>Select a resource type and resource to view planning.</p>
              </div>
              <div *ngIf="selectedResourceId" class="schedule-table-wrapper">
                <table class="schedule-table time-grid">
                  <thead>
                    <tr>
                      <th class="time-column">Time</th>
                      <th *ngFor="let day of days">{{ day }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let row of getResourceSessionRows(); let rowIdx = index">
                      <tr class="time-slot-row">
                        <td class="time-column">
                          <span class="time-label"
                                [class.round-hour]="row.timeSlot % 60 === 0">{{ row.timeString }}</span>
                        </td>
                        <td *ngFor="let day of [1,2,3,4,5,6,7]" class="day-cell">
                          <div class="day-columns-container">
                            <div *ngFor="let colIdx of createArray(row.maxColumns[day] || 1)"
                                 class="session-column"
                                 [style.width.%]="100 / (row.maxColumns[day] || 1)">
                              <ng-container *ngIf="row.sessionsByDayAndColumn[day] && row.sessionsByDayAndColumn[day][colIdx] as session">
                                <div class="resource-session-block grid-session"
                                     *ngIf="session.startHour === row.timeSlot"
                                     [style.height.px]="(session.endHour - session.startHour) / 5 * 23">
                                  <div class="resource-session-time">
                                    <span class="table-time">{{ session.startTime }} - {{ session.endTime }}</span>
                                  </div>
                                  <div class="resource-session-resources">
                                    <table class="resource-session-resource-table">
                                      <tbody>
                                        <ng-container *ngFor="let typeSlug of resourceTypeSlugs">
                                          <tr *ngIf="getAssociatedResources(session, selectedResourceTypeSlug ?? undefined, selectedResourceId ?? undefined)[typeSlug]?.length">
                                            <td class="resource-cell">
                                              <mat-icon class="resource-type-icon" [fontIcon]="getResourceTypeIcon(typeSlug) || 'person'" aria-hidden="true"></mat-icon>
                                              <ng-container *ngFor="let r of getAssociatedResources(session, selectedResourceTypeSlug ?? undefined, selectedResourceId ?? undefined)[typeSlug]; let last = last">
                                                <span class="resource-name">{{ r.name }}</span><span *ngIf="!last">, </span>
                                              </ng-container>
                                            </td>
                                          </tr>
                                        </ng-container>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
                <div *ngIf="resourceSessionsEmpty()" class="no-sessions">
                  <p>No sessions scheduled for this resource.</p>
                </div>
              </div>
            </ng-container>
            <!-- Type-per-day View -->
            <ng-container *ngSwitchCase="'typeperday'">
              <div style="display: flex; gap: 1.5em; align-items: flex-end; margin-bottom: 1.5em;">
                <!-- Day selector -->
                <mat-form-field appearance="outline" style="min-width: 160px; margin-top: 0; margin-bottom: 0;">
                  <mat-label>Day</mat-label>
                  <mat-select [(value)]="selectedTypePerDayDay" (selectionChange)="onTypePerDayDayChange($event.value)">
                    <mat-option *ngFor="let day of days; let i = index" [value]="i+1">
                      {{ day }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <!-- Resource type selector -->
                <mat-form-field appearance="outline" style="min-width: 200px; margin-top: 0; margin-bottom: 0;">
                  <mat-label>Resource Type</mat-label>
                  <mat-select [(value)]="selectedTypePerDayResourceTypeSlug" (selectionChange)="onTypePerDayResourceTypeChange($event.value)">
                    <mat-option *ngFor="let rt of scheduleDetailData.resourceTypes$ | async" [value]="rt.slug">
                      <mat-icon [fontIcon]="getResourceTypeIcon(rt.slug) || 'person'" style="margin-right: 0.5em;"></mat-icon>
                      {{ rt.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div *ngIf="!selectedTypePerDayDay || !selectedTypePerDayResourceTypeSlug" class="no-sessions">
                <p>Select a day and resource type to view planning.</p>
              </div>
              <div *ngIf="selectedTypePerDayDay && selectedTypePerDayResourceTypeSlug" class="schedule-table-wrapper">
                <table class="schedule-table time-grid">
                  <thead>
                    <tr>
                      <th class="time-column">Time</th>
                      <th *ngFor="let r of getResourcesOfTypeOnDay(selectedTypePerDayResourceTypeSlug, selectedTypePerDayDay)" class="resource-header">
                        <mat-icon class="resource-type-icon" [fontIcon]="getResourceTypeIcon(selectedTypePerDayResourceTypeSlug) || 'person'" aria-hidden="true"></mat-icon>
                        {{ r.name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let row of getTypePerDaySessionRows(); let rowIdx = index">
                      <tr class="time-slot-row">
                        <td class="time-column">
                          <span class="time-label"
                                [class.round-hour]="row.timeSlot % 60 === 0">{{ row.timeString }}</span>
                        </td>
                        <td *ngFor="let r of getResourcesOfTypeOnDay(selectedTypePerDayResourceTypeSlug, selectedTypePerDayDay)" class="resource-cell-grid">
                          <div class="resource-columns-container">
                            <div *ngFor="let colIdx of createArray(row.maxColumns[r.id] || 1)"
                                 class="session-column"
                                 [style.width.%]="100 / (row.maxColumns[r.id] || 1)">
                              <ng-container *ngIf="row.sessionsByResourceAndColumn[r.id] && row.sessionsByResourceAndColumn[r.id][colIdx] as session">
                                <div class="resource-session-block grid-session"
                                     *ngIf="session.startHour === row.timeSlot"
                                     [style.height.px]="(session.endHour - session.startHour) / 5 * 23">
                                  <div class="resource-session-time">
                                    <span class="table-time">{{ session.startTime }} - {{ session.endTime }}</span>
                                  </div>
                                  <div class="resource-session-resources">
                                    <table class="resource-session-resource-table">
                                      <tbody>
                                        <ng-container *ngFor="let typeSlug of resourceTypeSlugs">
                                          <tr *ngIf="getAssociatedResources(session, selectedTypePerDayResourceTypeSlug ?? undefined, r.id)[typeSlug]?.length">
                                            <td class="resource-cell">
                                              <mat-icon class="resource-type-icon" [fontIcon]="getResourceTypeIcon(typeSlug) || 'person'" aria-hidden="true"></mat-icon>
                                              <ng-container *ngFor="let res of getAssociatedResources(session, selectedTypePerDayResourceTypeSlug ?? undefined, r.id)[typeSlug]; let last = last">
                                                <span class="resource-name">{{ res.name }}</span><span *ngIf="!last">, </span>
                                              </ng-container>
                                            </td>
                                          </tr>
                                        </ng-container>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
                <div *ngIf="getResourcesOfTypeOnDay(selectedTypePerDayResourceTypeSlug, selectedTypePerDayDay).length === 0" class="no-sessions">
                  <p>No resources of this type scheduled for this day.</p>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </mat-card-content>

        <mat-card-actions align="end">
          <button
            mat-button
            color="primary"
            (click)="openScheduleAnalysis()"
            [disabled]="!selectedScheduleVersionInfo.number">
            Analyze Schedule
          </button>
          <button
            mat-button
            color="accent"
            (click)="openTechnicalAnalysis()"
            [disabled]="!selectedScheduleVersionInfo.number">
            Technical Analysis
          </button>
        </mat-card-actions>
      </mat-card>
      </div>
    </ng-template>
  </section>
</div>

<app-dashboard-footer></app-dashboard-footer>
